<template>
  <div class="container">
    <div class="main">
    <video class="movie item" muted control preload="auto"
        autoplay="autoplay" loop="loop" src="./img/base-login/login.mp4"></video>
    <div class="content">
      <div class="left">
        <div class="login">
          <div class="login-content">
            <div class="layui-tab"  lay-filter="loginTab">
              <div class="login-header">
                <p class="title">智码云通管理中心</p>
                <p class="title">数据分析及管理系统</p>
              </div>
              <div class="layui-tab-content">
                <div class="layui-tab-item  layui-show">
                  <form class="layui-form" method="post" action="" @keyup.enter="submit">
                    <div class="layui-form-item login-item">
                      <div class="layui-input-inline login-input">
                        <p>输入用户名</p>
                        <input type="text" name="username" required ref="username"
                            lay-verify="required" placeholder="请输入账号"
                            autocomplete="off" class="layui-input" />
                      </div>
                    </div>
                    <div class="layui-form-item login-item">
                      <p>输入密码</p>
                      <div class="layui-input-inline login-input">
                        <input type="password" name="password" required ref="password"
                            lay-verify="required" placeholder="请输入密码"
                            autocomplete="off" class="layui-input" />
                      </div>
                    </div>
                    <div class="layui-form-item login-item">
                      <div class="layui-input-inline">
                        <p>输入验证码</p>
                        <input type="text" name="vcode" required ref="vcode"
                            lay-verify="required" placeholder="请输入验证码"
                            autocomplete="off" class="layui-input" />
                      </div>
                      <div class="layui-form-mid login-vcode">
                        <img id="vcode-img" :src="verifyCode" alt="验证码"
                          @click="getVcodeImgUrl" style="cursor: pointer" />
                      </div>
                    </div>
                    <div class="layui-form-item">
                      <a href="/base/wxVerify" class="reset-pwd">忘记密码</a>
                    </div>
                    <div class="layui-form-item">
                      <div class="layui-input-block login-itemButton"
                        style="margin-left: 0">
                        <!-- <button class="layui-btn login-btn" lay-submit @click = "submit"
                            lay-filter="formLogin">
                          <span @click = "submit">登录</span>
                        </button> -->
                        <span class="layui-btn login-btn" @click = "submit">登录</span>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="layui-carousel" id="carouselList">
          <div carousel-item>
            <div>
              <img src="./img/base-login/banner1.png" />
            </div>
            <div>
              <img src="./img/base-login/banner2.png" />
            </div>
            <div>
              <img src="./img/base-login/banner3.png" />
            </div>
            <div>
              <img src="./img/base-login/banner4.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import '/src/css/layui/css/layui.css';
import '/src/css/layui/layui.js';

import { Message } from 'element-ui'
import { getVcode ,goLogin,getPermissionMenuListForTabBar,userInfo} from '@/api/systemData'
import {getToken,setToken,removeToken,getMenu,setMenus} from '@/utils/auth'
import Cookies from 'js-cookie'

export default {
  components: {
  },
  data() {
    return {
      verifyCode:"",
      loginData:{},
    }
  },
  computed: {
  },
  methods: {
    getVcodeImgUrl() {
      console.log("加载验证码");
      getVcode().then((res)=>{
        let url = window.URL.createObjectURL(new Blob([res], { type: 'image/png' }));
        this.verifyCode = url;
        // this.verifyCode = res;
        console.log("res",res);
      })
      // let url = '/verifyCode'
      // let getTimestamp = new Date().getTime()
      // if (url.indexOf('?') > -1) {
      //   url = url + '&timestamp=' + getTimestamp
      // } else {
      //   url = url + '?timestamp=' + getTimestamp
      // }
      // $('#vcode-img').attr('src', url)
    },
    submit(){
      let username = this.$refs.username.value;
      let password = this.$refs.password.value;
      let vcode = this.$refs.vcode.value;
      if(username == "" || password == "" || vcode == ""){
        Message({
          type: 'warning',
          message: "请填写完整信息",
        })
        return;
      }
      let loginData= {
        name:username,
        password:password,
        vcode:vcode
      }
      goLogin(JSON.stringify(loginData)).then((res)=>{
        console.log("res",res);
        if(res.success && res.code == 10000){
          //将token值保存到vuex中
          this.$store.dispatch('user/setToken',res.data); 
          console.log("token--getter",this.$store.getters.token);
          // this.$store.dispatch('menu/setMenu',2222); 
          setToken(res.data);
          //获取到当前登录人基本信息保存到本地sessionStorage中
          userInfo().then((res)=>{
            if(res.code == 10000){
              console.log("userInfo-res",res.data);
              //保存角色信息
              if(res.data != null){
                sessionStorage.setItem('roles', JSON.stringify(res.data.roles)); //保存角色
                sessionStorage.setItem('btnsPer', JSON.stringify(res.data.btnsPer)); //功能权限
                sessionStorage.setItem('adminId', res.data.id); //用户名
                sessionStorage.setItem('adminName', res.data.adminName); //用户名
                sessionStorage.setItem('mobile', res.data.mobile); //电话
                sessionStorage.setItem('companyId', res.data.companyId); //所属公司ID
                sessionStorage.setItem('companyName', res.data.companyName); //所属公司名称
                
              }
            }
          })
          //处理左侧菜单栏数据信息
          getPermissionMenuListForTabBar().then((res)=>{
              if(res.code == 10000){
                  const pidSelect = [];
                  if(res.data != null && res.data.length > 0){
                  let resultMunuList = res.data;
                  for(let i=0;i<resultMunuList.length;i++){
                      let obj={};
                        obj.path = resultMunuList[i].menuUrl;   // /Home
                        obj.name = resultMunuList[i].menuName;  //  Home
                        obj.menuTableTitle = resultMunuList[i].menuTableTitle  //总览
                        obj.component = () => import(`@/views${resultMunuList[i].menuUrl}/index.vue`)  
                        let metaObj = {};
                        metaObj.title = resultMunuList[i].menuTableTitle;  //总览
                        obj.id =  resultMunuList[i].id;
                        obj.pid =  resultMunuList[i].menuPid;
                        obj.meta = metaObj;

                        pidSelect.push(obj);
                  }
                  this.$store.dispatch('menu/setMenu',pidSelect); 
                  console.log("menus-store001",this.$store.getters.menus);
                  // let aa = JSON.stringify(pidSelect);
                  // console.log("aa+++",aa);
                  // console.log("aa----",JSON.parse(aa));
                  // localStorage.setItem("aa", JSON.stringify(aa));
                  // console.log("aa====", JSON.parse(localStorage.getItem("aa")));
                  setMenus(pidSelect);
                  this.$router.push('/index');

                  }
              }
          })
          

          const token = getToken(res.data);
          console.log("token-cookie",token);
        }else{
          Message({
            type: 'warning',
            message: res.message,
          })
        }
      })
    },
  },
  created() {
    this.getVcodeImgUrl();

  },
  mounted() {
    layui.use(['form', 'element', 'carousel','layer'], function () {
      var form = layui.form;
      var element = layui.element;
      var carousel = layui.carousel;
      var layer = layui.layer;

    //Tab切换
    element.on('tab(loginTab)', function(data){
    var index= data.index; //得到当前Tab的所在下标
    if(index == 3){
      wwInit();
    }
    if(index == 4){
        gwInit();
      }
    });
    
      //建造实例化
      carousel.render({
        elem: '#carouselList',
        width: '100%',
        height: '600px',
        arrow: 'always',
        indicator: 'inside',
      })
      
      //错误提示
      var error = getUrlParam("error");
      if(error!=null){
        if(error == 1){
          layer.msg('用户不存在或者未绑定！',{icon:5});
        }else if(error == 2){
          layer.msg('密码错误',{icon:5});
        }else if(error == 3){
          layer.msg('验证码错误',{icon:5});
        }else if(error == 4){
          layer.msg('第三方登录异常',{icon:5});
        }else{
          layer.msg('系统异常',{icon:5});
        }
      }
      //获取指定参数，可以设置默认值
      function getUrlParam(parameter, defaultvalue){
        var urlparameter = defaultvalue;
        if(window.location.href.indexOf(parameter) > -1){
            urlparameter = getUrlVars()[parameter];
            }
        return urlparameter;
      }
    })
  },
  destroyed() {},
}
</script>
<style lang="less" scoped>
    .container{
      width:100%;
      height:100vh;
      padding:0;
      margin:0;
      .main {
        width: 100%;
        min-width: 1200px;
        min-height: 600px;
        height: 100%;
        position: relative;
        overflow: hidden;

        }

        video {
          width: 100%;
        }

        .content {
          position: absolute;
          right: 90px;
          top: 90px;
          bottom: 90px;
          width: 1150px;
          height: 600px;
          min-height: 600px;
          background-color: #fff;
          border-radius: 10px;
          display: flex;
          justify-content: space-between;
        }


        .right {
          width: 500px;
          flex-shrink: 0;
        }

        .right img {
          width: 100%;
          height: 100%;
        }

        .login {
          width: 650px;
          height: 600px;
        }

        .layui-tab-title {
          text-align: center;
          border: none;

        }

        .layui-tab-title li {
          color: #b9bed3;
          font-size: 21px;
          padding-left: 10px;
          padding-right: 10px;
          cursor: pointer;
          font-weight: 600;
          position: relative;
        }

        .layui-tab-title li::after {
          content: '';
          position: absolute;
          top: 10px;
          right: 1px;
          height: 22px;
          color: #b9bed3;
          border-right: 2px solid #b9bed3;
        }

        .layui-tab-title li:nth-child(4n) {
          border-right: none;
          padding-right: 0px;
        }

        .layui-tab-title li:nth-child(4n)::after {
          border-right: none;
        }


        .layui-tab-title .layui-this {
          color: #6576b7;
        }

        .layui-tab-title .layui-this::after {
          top: 10px;
          right: 1px;
          height: 22px;
          border: none;
          border-right: 2px solid #b9bed3;
        }

        .login-header {
          margin-top: 35px;
          text-align: center;
        }

        .login-header .title {
          font-size: 21px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #444444;
          line-height: 40px;
        }

        .login .login-content {
          padding: 30px 40px;
        }

        .login-item {
          border-bottom: 1px solid #d8d8d8;
        }

        .login-input {
          width: 570px !important;
          margin-right: 0 !important;
        }

        .login-item input {
          border: none;
        }

        .login-vcode {
          float: right;
          /* font-size: 16px; */
          padding: 0px !important;
          /* background-color: #f5f5f5; */

        }
        .login-itemButton {
          text-align: center;
          margin-top: 30px;
        }

        .login-btn {
          width: 350px;
          height: 40px;
          background: #409EFF;
          box-shadow: 0px 4px 6px 0px rgba(99, 153, 234, 0.58);
          border-radius: 4px;
        }

        .login-btn span {
          height: 40px;
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 40px;
        }

        .reset-pwd {
          float: right;
          height: 22px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #6BA2F5;
          line-height: 22px;
        }
    }
</style>
